// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"248f350b","559":"5c050b5e"}[chunkId] + ".chunk.js";
};